import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Package, Check } from '@phosphor-icons/react';

export function ProductStep({ products, selectedProduct, formData, setFormData }) {
    return (
        <div className="space-y-3 pt-4 border-t">
            <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center text-xs font-medium">2</div>
                <h3 className="font-medium">Prodotto</h3>
            </div>

            {selectedProduct ? (
                <div className="p-3 bg-primary/5 border border-primary/20 rounded-lg">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                                <Package className="w-5 h-5 text-primary" />
                            </div>
                            <div>
                                <p className="font-medium">{selectedProduct.name}</p>
                                <p className="text-sm text-muted-foreground font-mono">{selectedProduct.code}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            {selectedProduct.has_default_workflow && (
                                <Badge variant="outline" className="text-xs text-green-700 border-green-300">
                                    <Check className="w-3 h-3 mr-1" />
                                    Workflow
                                </Badge>
                            )}
                            <Button
                                type="button"
                                variant="ghost"
                                size="sm"
                                onClick={() => setFormData({...formData, product_id: ''})}
                            >
                                Cambia
                            </Button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-1 gap-2">
                    {products.length === 0 ? (
                        <div className="p-4 text-center text-muted-foreground border rounded-lg">
                            <p>Nessun prodotto disponibile</p>
                            <p className="text-xs mt-1">Crea prima un prodotto nel Workflow Builder</p>
                        </div>
                    ) : (
                        products.map(product => (
                            <button
                                key={product.id}
                                type="button"
                                onClick={() => setFormData({...formData, product_id: product.id})}
                                className="p-3 text-left hover:bg-muted/50 border rounded-lg flex items-center gap-3 transition-colors"
                                data-testid={`product-option-${product.code}`}
                            >
                                <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
                                    <Package className="w-5 h-5 text-muted-foreground" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="font-medium">{product.name}</p>
                                    <p className="text-xs text-muted-foreground font-mono">{product.code}</p>
                                </div>
                                {product.has_default_workflow ? (
                                    <Badge variant="outline" className="text-xs text-green-700 border-green-300">
                                        {product.workflow_count} workflow
                                    </Badge>
                                ) : (
                                    <Badge variant="outline" className="text-xs text-amber-700 border-amber-300">
                                        No workflow
                                    </Badge>
                                )}
                            </button>
                        ))
                    )}
                </div>
            )}
        </div>
    );
}
